import { registerSurfaceItem } from "@/lib/surfaces";
import { lazyNamed } from "@/lib/lazyNamed";

/** US-010 — residents domain dashboard contributions. */
registerSurfaceItem("dashboard-banners", {
  id: "critical-alerts",
  // FIRST banner, ahead of subscription/billing. A resident with a DNR order,
  // an allergy or a mobility restriction outranks a trial-expired upsell —
  // previously this sat LAST (order 30), under a red billing banner, and was
  // the only one of the three you could dismiss.
  order: 5,
  Component: lazyNamed(
    () => import("./CriticalAlertsBanner"),
    "CriticalAlertsBanner",
  ),
});

registerSurfaceItem("dashboard-stats", {
  id: "active-residents",
  order: 10,
  Component: lazyNamed(
    () => import("./ActiveResidentsStatCard"),
    "ActiveResidentsStatCard",
  ),
});

registerSurfaceItem("dashboard-highlights", {
  id: "trend-alerts",
  order: 10,
  Component: lazyNamed(() => import("./TrendAlertsCard"), "TrendAlertsCard"),
});

registerSurfaceItem("dashboard-tables", {
  // Ordered before recent-admissions — today's schedule is time-sensitive
  // (staff act on it same-day); admissions history is reference material.
  id: "todays-appointments",
  order: 5,
  Component: lazyNamed(
    () => import("./TodaysAppointmentsCard"),
    "TodaysAppointmentsCard",
  ),
});

registerSurfaceItem("dashboard-tables", {
  id: "recent-admissions",
  order: 10,
  Component: lazyNamed(
    () => import("./RecentAdmissionsCard"),
    "RecentAdmissionsCard",
  ),
});
